import React from 'react';
import { AssetHyperlink, Hyperlink } from '@contentful/rich-text-types';
import { Asset } from 'contentful';

interface HyperLinkProps extends Hyperlink {
  type: 'PlainLink';
  openLinkSameWindow: false;
}

interface AssetHyperLinkProps extends AssetHyperlink {
  type: 'AssetLink';
  openLinkSameWindow: false;
}

// Link text has to be rendered itself as rich text
// to account for various formatting options (e.g. bold text)
export const HyperlinkRichText = (
  props: HyperLinkProps | AssetHyperLinkProps,
) => {
  let href: string;

  if (props.type === 'AssetLink') {
    const {
      fields: {
        file: { url },
      },
    } = props.data.target as unknown as Asset;
    href = url;
  } else {
    // must be regular link.
    href = props.data.uri;
  }

  const { value } = props?.content?.[0];

  return (
    <a
      href={href}
      target={props.openLinkSameWindow ? '_self' : '_blank'}
      rel="noopener noreferrer"
      className="font-bold text-blue-deep hover:underline hover:opacity-80"
    >
      {value}
    </a>
  );
};
